import { Image, Space } from 'antd';
import React from 'react';
import './Team.css';

interface ThisProps {
    nom: string;
    logo: string;
}

const Team: React.FC<ThisProps> = ({nom, logo}) => {

    // console.log(logo)
    return (
        <>
            <Space direction={"vertical"}>
                <div className="team">
                    <Image className="image" src={logo} preview={false}/>
                    <div className={"nom"}>{nom}</div>
                </div>
            </Space>
        </>
    );

}
export default Team;
